import React from "react";

import Editor from './EditorArticle'
import AutofillEditor from "./AutofillEditor"
import EditorWrapper from '../../EditorWrapper'

import Pot from "../../common/PhotoOnTop";
import EmptyArticle from "../../common/EmptyArticle";

const APhotoOnTop = props => {
  var article = EmptyArticle();
  const settings = props.settings;
  const imageUrl = (settings['background-image'] ? settings['background-image'] : '');
  const authorImg = (settings.author_img ? settings.author_img : "");

  article.title = props.autofill ? `Automatyczne wypełnienie: ${settings.autofill_category || 'podaj kategorię'}` : settings.title_normal;
  article.picture.img = (!!imageUrl ? window.MEDIA_DOMAIN + '/' + imageUrl.replace('.', ',780,0,0,0.') : '');
  article.url = settings.link;
  article.partner = settings.partner;
  article.label = settings.label;
  article.category = { name: settings.category };
  article.player = settings.player;
  article.stats = (settings.stats ? settings.stats : { shares: '0', comments: '0' });
  article.background = settings.background;

  // autor artykułu
  settings.show_author = (props.showAuthor || props.size == 'lg');
  article.author.show = settings.show_author;
  if (settings.show_author) {
    article.author.name = settings.author_name;
    article.author.img = window.MEDIA_DOMAIN + '/' + authorImg.replace('.', ',80,80,0,0.');
  }

  article.hasMobilePcs = props.blockSettings.pcs_background_mobile;
  article.hasDesktopPcs = props.blockSettings.pcs_background_desktop;

  if (settings.embed) {
    article.embed = settings.embed
  }

  // props.onRegisterBox(props.blockId, props.id, 'title_normal')

  return (
    <div className={props.classes + ' pos-relative'} {...props.events} >
      <EditorWrapper {...props} editor={props.autofill ? AutofillEditor : Editor} />
      <Pot article={article} size={props.size} imageHeight={props.imageHeight} media={settings.media} />
    </div>
  );
};

export default APhotoOnTop;
